export const getTeamIdOrSlug = (params: { teamId: number } | { teamSlug: string }) => {
  if ('teamId' in params) {
    return params.teamId
  }
  return params.teamSlug
}
